import React, {useMemo} from "react";
import {Redirect, Route, RouteComponentProps} from "react-router-dom";
import {useSelector} from "react-redux";
import {Navbar} from "mapx-components";
import {TUserReducerState} from "store/user/types";
import {userSelector} from "store/user/userSelectors";
import {PrivateRouteProps, TRootState} from "types";
import {pages as errorPages} from "mapx-pages/Error";
import withAuth from "withAuth";

const ALLOWED_ROLES = ["Admin", "MapX User", "RT+MapX User"];

const PrivateRoute: React.FC<PrivateRouteProps> = ({component, isAuthenticated, ...rest}) => {
	const Component = useMemo(
		() => component && withAuth(component as React.ComponentType<object>),
		[component],
	);

	const userInfo = useSelector(userSelector);

	const loggedOutManually = useSelector(
		(state: TRootState) => (state.user as TUserReducerState).loggedOutManually,
	);

	const getRouteComponent = (props: RouteComponentProps<{id?: string}>) => {
		const role = userInfo?.role;

		if (isAuthenticated) {
			if (role && ALLOWED_ROLES.includes(role)) {
				const baseKey = props.match.url.split("/")[1];
				const id = props.match.params?.id;
				const key = id !== undefined ? `${baseKey}/${id}` : baseKey;

				return Component ? (
					<div>
						<header>
							<Navbar />
						</header>
						<Component {...props} key={key} />
					</div>
				) : null;
			}

			return <Redirect to="/home" />;
		}

		const pathname = window.location.pathname as keyof typeof errorPages;
		const redirectTo =
			!loggedOutManually && pathname && !errorPages[pathname]
				? `?redirectTo=${pathname}`
				: "";

		return <Redirect to={`/login${redirectTo}`} />;
	};

	return <Route {...rest} render={(props) => getRouteComponent(props)} />;
};

export default PrivateRoute;
